import { render } from "./PointsReport.vue?vue&type=template&id=767234b2&scoped=true"
import script from "./PointsReport.vue?vue&type=script&lang=js"
export * from "./PointsReport.vue?vue&type=script&lang=js"

import "./PointsReport.vue?vue&type=style&index=0&id=767234b2&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767234b2"]])

export default __exports__